import { getSanxianStationData } from '../../api/weatherStationApis'
import Utils from '../../utils/utils'

const state = {
	SanxianStation: null
}

const getters = {
	getSanxianStationData: state => {
		return state.SanxianStation
	}
}

const actions = {
	async updateSanxianStationData({ commit }, condition) {
		commit('SanxianStation', await getSanxianStationData(condition))
	}
}

const mutations = {
	SanxianStation(state, data) {
		if (!Utils.isEmptyObject(data)) {
			state.SanxianStation = data
		}
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}